import actionTypes from "../actionTypes";

export const editPollResponse = (data) => ({
  type: actionTypes.socialTypes.EDIT_POLL_RESPONSE,
  payload: data,
});

export const copyPollResponse = (data) => ({
  type: actionTypes.socialTypes.COPY_POLL_RESPONSE,
  payload: data,
});

export const distributePollResponse = (data) => ({
  type: actionTypes.socialTypes.DISTRIBUTE_POLL_RESPONSE,
  payload: data,
});

export const setTenantPollUsers = (data) => ({
  type: actionTypes.socialTypes.GET_TENANT_POLL_USERS,
  payload: data,
});

export const setPollUserGroup = (data) => ({
  type: actionTypes.socialTypes.GET_POLL_USER_GROUP,
  payload: data,
});

export const setPollPreviewList = (data) => ({
  type: actionTypes.socialTypes.GET_POLL_PREVIEW_LIST,
  payload: data,
});

export const setPollLoader = (data) => ({
  type: actionTypes.socialTypes.SET_POLL_LOADER,
  payload: data,
});

export const setUnlockPollLoader = (data) => ({
  type: actionTypes.socialTypes.SET_UNLOCK_POLL_LOADER,
  payload: data,
});

export const setLockPollLoader = (data) => ({
  type: actionTypes.socialTypes.SET_LOCK_POLL_LOADER,
  payload: data,
});

export const setDeletePollLoader = (data) => ({
  type: actionTypes.socialTypes.SET_DELETE_POLL_LOADER,
  payload: data,
});

export const setCreateForumTopicResponse = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_TOPIC_RESPONSE,
  payload: data,
});

export const setCreateForumTooicLoader = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_TOPIC_LOADING,
  payload: data,
});

export const setEditForumTopicResponse = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.EDIT_FORUM_TOPIC_RESPONSE,
  payload: data,
});

export const setCreateForumThreadResponse = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.CREATE_FORUMT_THREAD,
  payload: data,
});

export const setForumTopics = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.FORUM_TOPICS,
  payload: data,
});

export const setCreateForumThreadLoader = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_THREAD_LOADER,
  payload: data,
});

export const setForumThreads = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.FORUM_THREADS,
  payload: data,
});

export const setCreateForumCommentLoader = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_COMMENT_LOADER,
  payload: data,
});

export const setViewComments = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.VIEW_COMMENTS,
  payload: data,
});

export const setShotClassFormData = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.SHOTCLASS_FORM_DATA,
  payload: data,
});

export const setDistributePollLoader = (data) => ({
  type: actionTypes.socialTypes.SET_DISTRIBUTE_POLL_LOADER,
  payload: data,
});

export const setisPollexistLoader = (data) => ({
  type: actionTypes.socialTypes.SET_IS_POLL_NAME_EXIST_LOADER,
  payload: data,
});

export const setForumTopicLoader = (data) => ({
  type: actionTypes.socialTypes.FORUM_AREA.SET_FORUM_TOPIC_LOADER,
  payload: data,
});

